export default {
  guideApiBaseUrl: "https://guideapi.learnbody.co.kr/",
  marketApiBaseUrl: "https://marketapi.learnbody.co.kr/",
  marketStorageUrl:
    "https://learnbodykr.blob.core.windows.net/",
  cdnUrl: "https://learnbodykr.blob.core.windows.net/spf/",
};
